<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2"  (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                id="117">
                    <h2>व्यापारी डैशबोर्ड  </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='31'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 " (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="117">
                    <label for="" class="mt-3">मर्चेंट डैशबोर्ड एक ऑनलाइन इंटरफ़ेस या प्लेटफ़ॉर्म है जो भुगतान गेटवे कंपनियों द्वारा व्यापारियों को प्रदान किया जाता है, जो उन्हें अपनी भुगतान प्रसंस्करण गतिविधियों के विभिन्न पहलुओं को प्रबंधित करने की अनुमति देता है। मर्चेंट डैशबोर्ड ऑनलाइन या पॉइंट-ऑफ-सेल लेनदेन में लगे व्यवसायों के लिए एक महत्वपूर्ण उपकरण है। यह एक केंद्रीकृत केंद्र के रूप में कार्य करता है जहां व्यापारी लेनदेन की निगरानी कर सकते हैं, विश्लेषण देख सकते हैं, सेटिंग्स कॉन्फ़िगर कर सकते हैं और अपने भुगतान-संबंधित कार्यों को सुव्यवस्थित करने के लिए टूल तक पहुंच सकते हैं। यह वित्तीय लेनदेन के प्रबंधन को सुव्यवस्थित करता है, व्यावसायिक प्रदर्शन में दृश्यता बढ़ाता है, और व्यापारियों को अपनी भुगतान प्रक्रियाओं को अनुकूलित करने के लिए आवश्यक नियंत्रण प्रदान करता है। </label>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="118">
                    <h2>
                        परीक्षण खाता डैशबोर्ड  
                    </h2>
                    <label for="" class="mt-3">पे जी में एक परीक्षण खाता एक सिम्युलेटेड या सैंडबॉक्स वातावरण है जो डेवलपर्स और व्यापारियों को वास्तविक लेनदेन या धन को संसाधित किए बिना भुगतान गेटवे की कार्यक्षमता का परीक्षण करने की अनुमति देता है। </label>

                    <ul>
                        <li class="mt-3">यह डेवलपर्स के लिए यह सुनिश्चित करने का एक तरीका है कि भुगतान गेटवे के साथ एकीकरण सही ढंग से काम करता है और लाइव या उत्पादन वातावरण में भुगतान प्रणाली को तैनात करने से पहले लेनदेन को ठीक से संभाला जा सकता है।  </li>

                        <li class="mt-3">परीक्षण खाता डैशबोर्ड आपके द्वारा पूरे किए गए चरणों की संख्या प्रदर्शित करेगा, और अपने खाते को सक्रिय करने के लिए, आपको अपना केवाईसी पूरा करना होगा। </li>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/md1.png" alt="" height="100%" width="100%">
                         </div>
                        <li class="mt-3">एक परीक्षण खाते में, व्यापारियों के पास आम तौर पर भुगतान लिंक, भुगतान बटन, चालान, ईज़ी कलेक्ट, स्मार्ट कलेक्ट और बुकिंग और टिकटिंग सहित डमी सुविधाओं के एक सेट तक पहुंच होती है। यह व्यापारियों को ईज़ी कलेक्ट और स्मार्ट कलेक्ट के लिए भुगतान लिंक, भुगतान बटन और प्रोफाइल का अनुकरण और निर्माण करने की अनुमति देता है। हालाँकि वे ये तत्व बना सकते हैं, लेकिन वे ग्राहकों से भुगतान स्वीकार नहीं कर पाएंगे। इसका उद्देश्य इन सुविधाओं के उचित और सुचारू कामकाज का परीक्षण करना है, यह सुनिश्चित करना है कि उनका भुगतान एकीकरण मजबूत और सुरक्षित है।  </li>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/md2.png" alt="" height="100%" width="100%">
                         </div>
                        <li class="mt-3">उत्पादों के बारे में सीखने की सुविधा के लिए व्यापारी परीक्षण खाता व्यापक दस्तावेज़ीकरण के साथ भी आता है। 

                        </li>
                    </ul>
                    <label for="" class="mt-2">परीक्षण खाता होने से डेवलपर्स को वास्तविक लेनदेन शामिल होने से पहले भुगतान प्रसंस्करण प्रवाह में किसी भी समस्या या बग को पहचानने और ठीक करने में मदद मिलती है, जिससे वास्तविक ग्राहकों को प्रभावित करने वाली समस्याओं का जोखिम कम हो जाता है। भुगतान गेटवे एकीकरण के विकास और परीक्षण चरणों के दौरान परीक्षण खातों का उपयोग करना सॉफ्टवेयर विकास और ई-कॉमर्स उद्योगों में एक आम बात है।    
                    </label>


                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="119">
                    <h2>सक्रिय खाता </h2>
                    <label for="" class="mt-3">पे जी में एक "सक्रिय खाता डैशबोर्ड" एक ऑनलाइन इंटरफ़ेस या प्लेटफ़ॉर्म को संदर्भित करता है जहां व्यापारी अपनी लाइव या सक्रिय भुगतान प्रसंस्करण गतिविधियों का प्रबंधन और निगरानी कर सकते हैं। यह डैशबोर्ड व्यापारियों को उनके वित्तीय लेनदेन के विभिन्न पहलुओं की निगरानी और नियंत्रण के लिए वास्तविक समय की जानकारी और उपकरण प्रदान करता है।  </label>

                    <ul>
                        <li class="mt-3">मुख्य विशेषताओं में अक्सर लेनदेन इतिहास, विश्लेषण, रिपोर्टिंग टूल और भुगतान विकल्प, खाता विवरण और सुरक्षा सेटिंग्स कॉन्फ़िगर करने की सेटिंग्स शामिल होती हैं। 
                        </li>

                        <li class="mt-3">व्यापारी राजस्व को ट्रैक करने, सफल लेनदेन की पहचान करने और ग्राहक भुगतान डेटा को सुरक्षित रूप से प्रबंधित करने के लिए सक्रिय खाता डैशबोर्ड का उपयोग कर सकते हैं। 

                        </li>
                    </ul>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="121">
                    <h2>सक्रिय खाता डैशबोर्ड में पाई जाने वाली कुछ सामान्य विशेषताएं यहां दी गई हैं:  </h2>

                    <ul>
                         <li class="mt-3"><b>लेन-देन अवलोकन: </b>&nbsp;  व्यापारी सफल भुगतान, रिफंड और चार्जबैक सहित हाल के लेन-देन का सारांश देख सकते हैं, जिससे वे एक नज़र में अपनी वित्तीय गतिविधियों पर नज़र रख सकते हैं।   </li>
                            
                        <li class="mt-3"><b>एनालिटिक्स और रिपोर्टिंग: </b>&nbsp;डैशबोर्ड में एनालिटिक्स टूल और रिपोर्टिंग विशेषताएं शामिल हैं जो बिक्री प्रदर्शन, ग्राहक व्यवहार और अन्य प्रासंगिक मेट्रिक्स में अंतर्दृष्टि प्रदान करती हैं। यह डेटा व्यापारियों को सूचित व्यावसायिक निर्णय लेने में मदद करता है। 

                        </li>

                        <li class="mt-3"><b>निपटान रिपोर्ट: </b>&nbsp;व्यापारी वित्तीय निपटान के बारे में विवरण प्राप्त कर सकते हैं, जिसमें दिखाया जाएगा कि लेनदेन से धनराशि उनके बैंक खाते में कब स्थानांतरित की जाएगी। यह जानकारी नकदी प्रवाह और वित्तीय योजना के प्रबंधन में मदद करती है।  

                        </li>

                        <li class="mt-3"><b>सेटिंग्स और कॉन्फ़िगरेशन: </b>&nbsp;व्यापारी अपने खातों से संबंधित विभिन्न सेटिंग्स, जैसे ब्रांडिंग, सूचनाएं और अन्य प्राथमिकताओं को अनुकूलित कर सकते हैं, जिससे उन्हें अपनी भुगतान प्रक्रियाओं पर नियंत्रण मिलता है। 

                        </li>
                    </ul>
                    <label for="" class="mt-2"> संक्षेप में, भुगतान गेटवे कंपनी में एक सक्रिय खाता डैशबोर्ड व्यापारियों को अपनी लाइव भुगतान प्रसंस्करण गतिविधियों को सक्रिय रूप से प्रबंधित और अनुकूलित करने के लिए आवश्यक उपकरण और जानकारी प्रदान करता है। यह लेनदेन की निगरानी, प्रदर्शन का विश्लेषण और विशिष्ट व्यावसायिक आवश्यकताओं को पूरा करने के लिए सेटिंग्स कॉन्फ़िगर करने का एक केंद्रीय केंद्र है। 

                    </label>

                </div>
                
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची :
                    </h5>

                </div>

                <!-- <div class="col-md-12 mt-2">
                    <a href="#31"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10"><span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Refunds </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-2">
                    <a href="#117">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10"><span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')">
                                    व्यापारी डैशबोर्ड   </span>

                            </div>

                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#118">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">परीक्षण खाता डैशबोर्ड  
                                </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#119">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    सक्रिय खाता डैशबोर्ड   </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#121">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"  [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">सक्रिय खाते की विशेषताएं  </span>

                            </div>
                        </div>
                    </a>
                </div>


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/report']">     <button class="btn btn-color" (click)="menues('Reports')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;रिपोर्टस 
                </button></a>
               
        </div>
    </div>
</div>